import { render, staticRenderFns } from "./ViewSwitcher.vue?vue&type=template&id=1fdd5a68&scoped=true&"
import script from "./ViewSwitcher.vue?vue&type=script&lang=js&"
export * from "./ViewSwitcher.vue?vue&type=script&lang=js&"
import style0 from "./ViewSwitcher.vue?vue&type=style&index=0&id=1fdd5a68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdd5a68",
  null
  
)

export default component.exports